import {
  Component,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import type { LeafSearchField } from '@cigna/leaf-web/lib/wc/components/search-field/search-field';
import '@cigna/leaf-web/lib/wc/components/search-field/search-field';

@Component({
  selector: 'cigna-leaf-search-field',
  template: `
    <leaf-search-field
      [label]="label"
      [value]="value"
      [name]="name"
      [fieldNote]="fieldNote"
      [buttonDisplay]="buttonDisplay"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
      (blur)="onTouched()"
      (input)="inputHandler($event.target.value)"
      (search-event)="search.emit($event.detail.value)"
    ></leaf-search-field>
  `,
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CignaLeafSearchFieldComponent),
      multi: true,
    },
  ],
})
export class CignaLeafSearchFieldComponent implements ControlValueAccessor {
  @Input() label: LeafSearchField['label'];
  // @Input() suggestions: LeafSearchField['suggestions'];

  @Input() buttonDisplay: LeafSearchField['buttonDisplay'];
  @Input() name: LeafSearchField['name'];
  @Input() fieldNote: LeafSearchField['fieldNote'];
  @Input() isOptional: LeafSearchField['isOptional'] = false;
  @Input() optionalText: LeafSearchField['optionalText'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Output() search = new EventEmitter<string>();
  @Output() change = new EventEmitter<string>();

  private _value = '';

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTouched: any = () => {};

  inputHandler(val: string) {
    this._value = val;
    this.onTouched();
    this.onChange(this._value);
    this.change.emit(val);
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(val) {
    if (val !== this._value) {
      this._value = val;
      this.onTouched();
    }
  }

  writeValue(value: string) {
    this.value = value;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
